import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigateToHome = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/StudZone/home');
  }, [navigate]);

  return null;
};

export default NavigateToHome;